module.exports = __webpack_public_path__ + "static/media/Retro-Sprint-2-Audio-1.d7c8a58b.mp3";